import { useFormik } from 'formik';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useCampaignStore } from 'store/campaignStore';
import { useOrderStore } from 'store/orderStore';

interface BaseFormProps {
  values: ReturnType<typeof useFormik>['values'];
  setFieldValue: ReturnType<typeof useFormik>['setFieldValue'];
}
const useBaseForm = (
  initialState: BaseFormProps = {
    values: {},
    setFieldValue: async (
      field: string,
      value: any,
      shouldValidate?: boolean,
    ) => Promise.resolve(),
  },
) => {
  const { setFieldValue } = initialState;
  const history = useHistory();
  const { order } = useOrderStore();
  const { actionType } = useCampaignStore();

  const campaignMinDate =
    moment(order?.startDate).diff(moment(), 'days') > 0
      ? moment(order?.startDate)
      : moment();

  const handleCampaignNameChange = (newCampaignName) => {
    setFieldValue('basic.name', newCampaignName);
  };

  // 返回上一頁
  const handleBack = () => {
    if (actionType === 'edit' || actionType === 'copy') {
      return history.push(`/orders/${order?.orderNumber}`);
    }
    return history.push(
      `/orders/${order?.orderNumber}/campaigns/select-adType`,
    );
  };

  return {
    campaignMinDate,
    handleCampaignNameChange,
    handleBack,
  };
};

export default useBaseForm;
